import { render } from "./HeaderShadow.vue?vue&type=template&id=54ca71c9&ts=true"
import script from "./HeaderShadow.vue?vue&type=script&lang=ts"
export * from "./HeaderShadow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__